/**
 * WordPress dependencies
 */
import { getPhrasingContentSchema } from '@wordpress/blocks';
var tableContentPasteSchema = {
  tr: {
    allowEmpty: true,
    children: {
      th: {
        allowEmpty: true,
        children: getPhrasingContentSchema(),
        attributes: ['scope']
      },
      td: {
        allowEmpty: true,
        children: getPhrasingContentSchema()
      }
    }
  }
};
var tablePasteSchema = {
  table: {
    children: {
      thead: {
        allowEmpty: true,
        children: tableContentPasteSchema
      },
      tfoot: {
        allowEmpty: true,
        children: tableContentPasteSchema
      },
      tbody: {
        allowEmpty: true,
        children: tableContentPasteSchema
      }
    }
  }
};
var transforms = {
  from: [{
    type: 'raw',
    selector: 'table',
    schema: tablePasteSchema
  }]
};
export default transforms;
//# sourceMappingURL=transforms.js.map